import React, { useEffect, useRef } from 'react';

import { Alert, Box, Modal, ScrollBox, Text } from '~/components/blocks';
import { MailSenderForm, PractitionerAuthenticationInformation } from '~/components/partials';
import { Fields } from '~/components/partials/MailSenderForm/types';
import {
  Organization,
  Practitoner,
} from '~/components/partials/PractitionerAuthenticationInformation/types';

type Props = {
  error: string | null;
  sending: boolean;
  organization: Organization;
  practitioner: Practitoner;
  practitionerCode: string;
  onSend: (values: Fields) => void;
};

export const CompleteRegistrationPanel = React.memo((props: Props) => {
  const { error, sending, organization, practitioner, practitionerCode } = props;
  const scrollRef = useRef<RefAttributeType<typeof ScrollBox> | null>(null);

  useEffect(() => {
    if (error) {
      scrollRef.current?.toTop();
    }
  }, [error]);

  return (
    <>
      <Modal.Header>スタッフ登録完了</Modal.Header>
      <Modal.Body>
        <ScrollBox ref={scrollRef}>
          {error && (
            <Alert status="error" marginBottom="xl">
              {error}
            </Alert>
          )}
          <Text size="s" color="green" fontWeight="bold">
            ログイン情報をメールで送信、または印刷することをお勧めします
          </Text>
          <Box my="m">
            <MailSenderForm
              initialValues={{ email: '' }}
              sending={sending}
              onSubmit={props.onSend}
            />
          </Box>
          <PractitionerAuthenticationInformation
            disabled={sending}
            organization={organization}
            practitioner={practitioner}
            practitionerCode={practitionerCode}
          />
        </ScrollBox>
      </Modal.Body>
    </>
  );
});

CompleteRegistrationPanel.displayName = 'CompleteRegistrationPanel';
